











































import {Component, Vue} from "vue-property-decorator";
import {PartnerStore} from "@/modules/partners/store";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import PartnerLabel from "@/modules/partners/List/components/Label.vue";
import PartnerTypeLabel from "@/modules/partners/List/components/PartnerTypeLabel.vue";
import PartnerTableAction from "@/modules/partners/List/components/TableAction.vue";
import PartnerSearch from "@/modules/partners/List/components/Search.vue";
import {PartnerParams} from "@/modules/partners";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

const columns =  [
    {
        title: "Thao tác",
        dataIndex: "rowGuid",
        key: "action",
        scopedSlots: { customRender: 'action' },
        align: 'center',
        width: 100,
    },
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50
    },
    {
        title: "Mã đối tác",
        dataIndex: "code",
        key: "code",
        width: 100,
        ellipsis: true
    },
    {
        title: "Tên đối tác",
        dataIndex: "name",
        key: "name",
        width: 120,
        ellipsis: true,
        scopedSlots: {customRender: "name"}
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        width: 100,
        ellipsis: true,
        scopedSlots: {customRender: "phoneNumber"}
        
    },
    {
        title: "Địa chỉ",
        dataIndex: "address",
        key: "address",
        width: 200,
        ellipsis: true,
        scopedSlots: {customRender: "address"}
    },
    {
        title: "Loại đối tác",
        dataIndex: "type",
        key: "type",
        scopedSlots: { customRender: "type" },
        width: 100,
        ellipsis: true,
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        scopedSlots: { customRender: 'status' },
        width: 100,
        ellipsis: true
    }
];

@Component({
    name: "PartnerList",
    components: {TooltipLabel, PartnerSearch, PartnerTableAction, PartnerTypeLabel, PartnerLabel, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = columns;

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...columns,
                {
                    title: "Bưu cục",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    width: 150,
                    ellipsis: true
                } as any
            ];
        }
        PartnerStore.updatePartnerParams(new PartnerParams());
        PartnerStore.listPartner({ params: PartnerStore.params, refresh: true });
    }

    get partners() {
        return PartnerStore.ids.map((id: string) => PartnerStore.data[id]);
    }

    get pagination() {
        return {
            current: PartnerStore.meta.page,
            pageSize: PartnerStore.meta.limit,
            total: PartnerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} đối tác`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        const params = {...PartnerStore.params, page: pagination.current, limit: pagination.pageSize};
        PartnerStore.listPartner({ params, refresh: true });
    }

    createPartner() {
        this.$router.push({ name: "createPartner" });
    }
}
